import dayjs from "dayjs";
import i18n from "@/i18n";
import { Printer } from "@/types";

const { t } = i18n.global;

export const PRINTER_STALE_HOURS = 1;

export function getPrinterStatusColor(printer: Printer): string {
  if (printer.status?.toLocaleLowerCase() === "offline") return "text-red-500";
  if (dayjs().diff(dayjs(printer.updatedAt), "hour") >= PRINTER_STALE_HOURS) return "text-gray-500";
  return "text-green-500";
}

export function getPrinterStatusName(printer: Printer): string {
  if (printer.status?.toLocaleLowerCase() === "offline") return t("Offline");
  if (dayjs().diff(dayjs(printer.updatedAt), "hour") >= PRINTER_STALE_HOURS) return t("Unknown");
  return t(printer.status);
}

export function getPrinterStatusBorderColor(printer: Printer): string {
  if (printer.status?.toLocaleLowerCase() === "offline") return "border-l-red-400";
  if (dayjs().diff(dayjs(printer.updatedAt), "hour") >= PRINTER_STALE_HOURS) return "border-l-gray-400";
  return "border-l-green-400";
}

export function getPrinterDescription(printer: Printer | null | undefined): string {
  if (!printer) return "";
  return printer.alias || printer.name || "";
}

export function naturalCompare(a: string, b: string): number {
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
  return collator.compare(a, b);
}
